import {
  Component, OnInit, OnDestroy, AfterViewInit,
  ViewChild, ElementRef
} from '@angular/core';
import {Subscription } from 'rxjs/Rx';

import { MapsService } from './index';
import * as _ from 'lodash';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('map') map: ElementRef;
  @ViewChild('streetview') streetview: ElementRef;
  @ViewChild('search') search: ElementRef;
  public showSearch: boolean;
  private gmap: any;
  private streetViewIsEnabled: boolean;
  private subscriptions: Subscription[];

  constructor(private mapsService: MapsService) { }
  ngOnInit() {
    this.subscriptions = [];
    this.streetViewIsEnabled = false;
    this.showSearch = false;

    this.subscribeStreetview();
    this.subscribeFocus();
    this.subscribeSearch();
  }

  subscribeSearch(): void {
    this.subscriptions.push(this.mapsService.getshowSearch$()
      .subscribe((toggle: boolean) => {
        this.showSearch = toggle;
        setTimeout(() => {
          if (toggle) {
            this.mapsService.bindSearch(this.search);
          } else {
            this.mapsService.unbindSearch();
          }
        }, 0);
      }));
  }

  subscribeFocus(): void {
    this.subscriptions.push(
      this.mapsService.getFocusSearch()
        .subscribe(() => {
          this.focusSearch();
        })
    );
  }

  focusSearch(): void {
    let input = this.search.nativeElement.querySelector('input.search-box').focus();
  }

  subscribeStreetview(): void {
    this.subscriptions.push(this.mapsService.getStreetViewToggledObservable()
      .subscribe((toggle: boolean) => {
        this.streetViewIsEnabled = toggle;
        setTimeout(() => {
          if (this.streetViewIsEnabled) {
            this.mapsService.enableSplit(this.streetview);
          } else {
            this.mapsService.disableSplit();
          }
        }, 0);
      }));
  }

  ngAfterViewInit() {
    this.mapsService.initMap(this.map);
  }

  streetViewEnabled(): boolean {
    return this.streetViewIsEnabled;
  }

  ngOnDestroy() {
    _.each(this.subscriptions, (sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps/maps.component.ts